module.exports = __webpack_public_path__ + "static/media/EL-Avatar.f2b2ec46.png";